export default "__VITE_ASSET__KLsFEnix__"